import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import FilePicker from '../file-picker/components/file-picker';
import { FILE_PICKER_PROPS } from '../file-picker/components/file-picker/types';

const defaultRules = {};

const FilePickerField = ({
  name,
  control,
  rules = defaultRules,
  statusText = '',
  onChange = Function.prototype,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (newValue) => {
      field.onChange(newValue);
      onChange(newValue);
    },
    [field, onChange]
  );

  return (
    <FilePicker
      {...otherProps}
      invalid={fieldState.invalid}
      statusText={statusText || fieldState?.error?.message}
      onChange={handleChange}
    />
  );
};

FilePickerField.propTypes = {
  ...FILE_PICKER_PROPS,
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  statusText: PropTypes.string,
  onChange: PropTypes.func,
};

export default FilePickerField;
